import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../elements/Humberg.jsx";

import { useDispatch, useSelector } from "react-redux";
import { allPendingUsersAction,  clearErrors } from "../../redux/actions/userActions.js";
import SinglePMM from "./singlePmm.jsx";
import LoaderBlock from "../loader/LoaderBlock.jsx";
import { toast } from "react-toastify";
import { APPROVE_USER_RESET, UPDATE_USER_STATUS_RESET } from "../../redux/constants/userConstant.js";
import api from "../../api.js";


const Admins = () => {



    const dispatch = useDispatch()

    const { loading, users,  totalPages } = useSelector((state) => state.pendingUsers)
    const { user } = useSelector((state) => state.verifyEmailStore)

    const { error, message } = useSelector(state => state.inviteUser)





    const [keyword, setKeyword] = useState('');
    const [perPage, setPerPage] = useState('20');
    const [page, setPage] = useState(1);
    const [pmmCount, setPmmCount] = useState(0);
    const [pmCount, setPmCount] = useState(0);
    const [exporting, setExporting] = useState(false);



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("pending-approvals");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        subElement?.classList.add("activeSubLink");

        document.title = `PMM List - Admin Panel`;

    }, []);
    // Remove one quantity






    useEffect(() => {

        let query = {}
        if (keyword) query.keyword = keyword
        if (perPage) query.perPage = perPage
        query.status = 'PENDING_APPROVAL'
        query.page = page


        dispatch(allPendingUsersAction(query))

    }, [keyword, perPage, page, dispatch])



    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: UPDATE_USER_STATUS_RESET })
            dispatch({ type: APPROVE_USER_RESET })
            let query = {}
            if (keyword) query.keyword = keyword
            if (perPage) query.perPage = perPage
            query.status = 'PENDING_APPROVAL'
            query.page = page
            dispatch(allPendingUsersAction(query))
        }


    }, [error, message, dispatch, page, keyword, perPage])



    useEffect(() => {
        if (users?.length > 0) {

            let pmCounter = 0;
            let pmmCounter = 0;


            users?.forEach( (userData) => {
                if (userData.role === "PM") {
                    pmCounter++;
                }
                else {
                    pmmCounter++;
                }
            })

            setPmCount(pmCounter);
            setPmmCount(pmmCounter);
        }
    }, [users])

    const handleExportExcel = async () => {
        try {
            setExporting(true);

            const query = {};
            if (keyword) query.keyword = keyword;

            const queryString = new URLSearchParams(query).toString();
            const url = queryString
                ? `/api/v1/export-pending-approval-users?${queryString}`
                : `/api/v1/export-pending-approval-users`;

            const response = await api.get(url, { responseType: "blob" });
            const blob = new Blob([response.data], { type: response.data.type });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `pending_approvals_${Date.now()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(link.href);
            toast.success("Pending approvals exported successfully");
        } catch (error) {
            if (error.response?.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const err = JSON.parse(reader.result);
                        toast.error(err.message || "Export failed");
                    } catch {
                        toast.error("Export failed");
                    }
                };
                reader.readAsText(error.response.data);
            } else {
                toast.error(error.response?.data?.message || error.message || "Export failed");
            }
        } finally {
            setExporting(false);
        }
    };


    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"Pending Approval"} />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                <div className="flex justify-center gap-[1.5vmax] mb-[2vmax] flex-wrap">
                    {/* PMMs Stat Card */}
                    <div className="flex-1 min-w-[200px] bg-white p-[1.5vmax] rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                        <div>
                            <span className="text-[2vmax] font-bold text-gray-800 block">{pmmCount || 0}</span>
                            <span className="text-gray-500 font-medium text-[0.9vmax] uppercase tracking-wider">PMMs</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-green-50 text-green-600 rounded-full flex items-center justify-center">
                            <i className="fa-solid fa-user text-[1.5vmax]"></i>
                        </div>
                    </div>

                    {/* PMs Stat Card */}
                    <div className="flex-1 min-w-[200px] bg-white p-[1.5vmax] rounded-xl border border-gray-100 shadow-sm flex justify-between items-center">
                        <div>
                            <span className="text-[2vmax] font-bold text-gray-800 block">{pmCount || 0}</span>
                            <span className="text-gray-500 font-medium text-[0.9vmax] uppercase tracking-wider">PMs</span>
                        </div>
                        <div className="w-[3vmax] h-[3vmax] bg-blue-50 text-blue-600 rounded-full flex items-center justify-center">
                            <i className="fa-solid fa-user text-[1.5vmax]"></i>
                        </div>
                    </div>
                </div>

                <div className="bg-white p-[2vmax] rounded-xl border border-gray-100 shadow-sm">
                    <div className="flex justify-between gap-[1.5vmax] items-center mb-[2vmax] flex-wrap">
                        {/* Search */}
                        <div className="w-full lg:w-[350px] flex items-center bg-gray-50 border border-gray-100 p-[0.7vmax_1vmax] rounded-lg focus-within:border-indigo-300 transition-colors">
                            <span className="text-gray-400 mr-[0.5vmax]" >
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </span>
                            <input 
                                type="text" 
                                className="w-full bg-transparent outline-none text-[0.9vmax] font-medium text-gray-700 placeholder-gray-400" 
                                placeholder="Search By Name, email, phone or ID"
                                value={keyword}
                                onChange={(e) => {
                                    setKeyword(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>

                        {/* Per Page */}
                        <div className="flex items-center gap-[0.5vmax]">
                            <span className="text-gray-500 font-medium text-[0.9vmax]">Show:</span>
                            <div className="relative bg-gray-50 border border-gray-100 rounded-lg focus-within:border-indigo-300 transition-colors">
                                <select 
                                    className="pl-[1vmax] pr-[2vmax] py-[0.7vmax] text-[0.9vmax] font-medium text-gray-700 outline-none bg-transparent appearance-none"
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(e.target.value)
                                        setPage(1)
                                    }}
                                >
                                    <option value="1">1</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                </select>
                                <span className="absolute right-[0.7vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <i className="fa-solid fa-chevron-down text-xs"></i>
                                </span>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={handleExportExcel}
                            disabled={exporting || loading}
                            className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition-all hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-emerald-500 dark:text-slate-950 dark:hover:bg-emerald-400"
                        >
                            <i className={`fa-solid ${exporting ? "fa-spinner fa-spin" : "fa-file-excel"}`}></i>
                            {exporting ? "Exporting..." : "Export Excel"}
                        </button>
                    </div>

                    <div className="w-full overflow-x-auto">
                        <div className="flex bg-zinc-50 border border-zinc-100 py-[1vmax] rounded-xl min-w-[1400px] mb-[1.5vmax] shadow-sm">
                            <div className="text-center flex-[0.4] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                No.
                            </div>
                            <div className="px-[1vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                Name
                            </div>
                            <div className="px-[1vmax] flex-[2] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                Email
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                Phone
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[0.8] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                User Type
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[0.8] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                User ID
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.2] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                Refered By
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                JOINED
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[3] text-zinc-600 font-jakarta font-semibold uppercase text-[1.4vmax] lg:text-[0.8vmax] tracking-wider" >
                                Actions
                            </div>
                        </div>

                        {loading ?
                            <LoaderBlock />
                            :
                            users?.length > 0 ?
                                users.map((userData, index) =>
                                    <SinglePMM key={userData.id} PMM={userData} index={index} page={page} perPage={perPage} user={user}
                                    />)
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>

                        }
                    </div>
                </div>

            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

        </Fragment>
    );
};

export default Admins;
